import type { NotificationCenterWhitelabelTemplate } from "@/types/notification-center"

/**
 * Filtra a lista de templates por um termo de busca, comparando com o NOME ou o
 * CONTEÚDO (source) do template, case-insensitive. Termo vazio/undefined devolve
 * a lista inteira. Client-side: a listagem vem inteira do backend (sem paginação)
 * e o endpoint não aceita filtro textual.
 */
export const filterTemplatesBySearchTerm = (
  templates: NotificationCenterWhitelabelTemplate[],
  term?: string
): NotificationCenterWhitelabelTemplate[] => {
  const normalized = term?.trim().toLowerCase()

  if (!normalized) {
    return templates
  }

  return templates.filter(
    (template) =>
      template.name?.toLowerCase().includes(normalized) ||
      template.source?.toLowerCase().includes(normalized)
  )
}
